import qrcode, { QRCodeRenderersOptions } from 'qrcode';
import { useEffect, useRef } from 'react';

interface QRCodeProps {
  code: string;
  options?: QRCodeRenderersOptions;
  callback?: (error: Error | null | undefined) => void;
}

export const QRCode = (props: QRCodeProps) => {
  const { code, options, callback } = props;
  const ref = useRef(null);

  useEffect(() => {
    qrcode.toCanvas(ref.current, code, options ?? {}, callback ?? (() => {}));
  }, [code, options, callback]);

  return <canvas ref={ref} />;
};
